module.exports = __webpack_public_path__ + "img/cog_stop.70f31eb0.jpg";